import React from 'react';
import SEOHead from '../components/SEOHead';
import Navbar from '../components/Navbar';
import HeroSlider from '../components/HeroSlider';
import Ticker from '../components/Ticker';
import Services from '../components/Services';
import About from '../components/About';
import Clients from '../components/Clients';
// import Stats from '../components/Stats';
import FloatingElements from '../components/FloatingElements';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <SEOHead />
      <Navbar />
      <main id="main-content" style={{ position: 'relative', overflow: 'hidden' }}>
        <FloatingElements />
        <HeroSlider />
        <Ticker />
        <Services />
        <About />
        <Clients />
        {/* <Stats /> */}
        {/* <VideoSection /> */}
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default Home;
